import React, { useState, useEffect } from "react";
import {
  Modal,
  Card,
  IconButton,
  Box,
  Typography,
  Button,
  Grid,
  TextField
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CallIcon from "@mui/icons-material/Call";
 import { fetchSecretKey } from "encryptionAndDecryption/secretKeyDecryption";
 import { encryptBody } from "encryptionAndDecryption/bodyEncryption";
 import axios from "api/baseurl";
 import { toast } from "react-toastify";
  import { decryptBody } from "encryptionAndDecryption/bodyDecryption";
   import MDButton from "components/MDButton";
   import BackspaceIcon from '@mui/icons-material/Backspace';

function DoctorPhoneCallModal({ open,
  onClose,
  phoneNumber: initialNumber,
  doctorid:doctorid,
  userid:userid,
  fetchProgressNotes }) {
  const [phoneNumber, setPhoneNumber] = useState(initialNumber || "");
  const [note, setNote] = useState("");
  const [progressNote, setProgressNote] = useState({
    notes:""
  });
   const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");


  useEffect(() => {
    if (open) {
      setPhoneNumber(initialNumber || "");
      setNote("");
      setProgressNote("");   // Reset Progress Note on open
    }
  }, [open, initialNumber]);

  const dial = async () => {
  if (!phoneNumber) return;

  

  window.location.href = `tel:${phoneNumber}`;

  // Reset fields
  setNote("");
  setPhoneNumber(initialNumber || "");
  onClose();
};


  const addDigit = (digit) => setPhoneNumber((prev) => prev + digit);
  const deleteDigit = () => setPhoneNumber((prev) => prev.slice(0, -1));

  const handleCancel = () => {
    setPhoneNumber(initialNumber || "");
    setNote("");
    setProgressNote("");   // Clear Progress Note
    onClose();
  };

 const handleSubmit = async (e) => {
     
     e.preventDefault();
   
//     if (!progressNote.notes.trim()) {
//     setError("Progress note is required.");
//     return;
//   }

//   if (progressNote.notes.trim().length < 3) {
//     setError("Progress note must be at least 3 characters.");
//     return;
//   }

    setError(""); // clear error
     setLoading(true);
       try {
         
         const secretKey = await fetchSecretKey();
       
         
         const rawPayload = {
               id: "",
              ccid: userid,
              doctorid: doctorid,
              notes: progressNote.notes,
             };
     
         console.log("Raw Payload Before Encryption:", rawPayload); 
     
         const encryptedData = encryptBody(rawPayload, secretKey);
     
         console.log("Encrypted Payload:", encryptedData);
     
         const token = JSON.parse(localStorage.getItem("loginData")).token;
     
         // Register Dealer
         const response = await axios.post("/api/doctornotes/create", encryptedData, {
           headers: {
             "Content-Type": "application/json",
             Authorization: `Bearer ${token}`,
           },
         });
     
        if (response.status === 200) {
  const decryptedResponse = decryptBody(response.data, secretKey);
  console.log("Decrypted Response:", decryptedResponse);

  // Backend returns an object, not { success: true }
  if (!decryptedResponse || !decryptedResponse.id) {
    toast.error("Failed to save progress notes.");
    return;
  }

  toast.success("Progress Note added successfully!");

   // Close modal
      onClose();

      // Refresh notes list if function is provided
      fetchProgressNotes?.();


} else {
  toast.error("Failed to save progress notes.");
}

      } catch (error) {
     console.error("Registration Error:", error);
   
     let errorMessage = "Registration failed"; // default message
   
     if (error.response) {
       const data = error.response.data;
   
       // ✅ If backend sends a structured JSON with a 'message' field
       if (typeof data === "object" && data.message) {
         errorMessage = data.message;
       } 
       // ✅ If backend sends a plain text message
       else if (typeof data === "string") {
         errorMessage = data;
       }
     } 
     // ✅ For network or other unexpected errors
     else if (error.message) {
       errorMessage = error.message;
     }
   
     toast.error(errorMessage);
   } finally {
     setLoading(false);
   }
     };

  const numbers = [
    ["1", "2", "3"],
    ["4", "5", "6"],
    ["7", "8", "9"],
    ["*", "0", "#"],
  ];

  return (
    <Modal open={open} onClose={handleCancel}>
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh" p={1}>
        <Card
          sx={{
            width: "260px",
            padding: 1.5,
            borderRadius: "14px",
            position: "relative",
            boxShadow: "0 3px 10px rgba(0,0,0,0.2)",
          }}
        >
          {/* Close Icon */}
          <IconButton 
            onClick={handleCancel} 
            sx={{ position: "absolute", top: 6, right: 6, color: "#000" }} 
            size="small"
          >
            <CloseIcon fontSize="small" />
          </IconButton>

          {/* Title */}
          <Box textAlign="center" mb={1} sx={{ fontWeight: "bold" }}>
            <Box component="span" sx={{ color: "#00C853", fontSize: "1.2rem" }}>📞</Box>{" "}
            <Box component="span">Phone Call</Box>
          </Box>

          {/* Phone Number Display */}
          <Box
            sx={{
              background: "#f5f5f5",
              padding: "8px",
              borderRadius: "8px",
              textAlign: "center",
              fontSize: "16px",
              fontWeight: "bold",
              mb: 1,
            }}
          >
            {phoneNumber || "No Number"}
          </Box>

          {/* Dial Pad */}
          <Grid container spacing={0.4} justifyContent="center">
            {numbers.flat().map((num) => (
              <Grid item xs={4} key={num}>
                <Button
                  variant="outlined"
                  fullWidth
                  onClick={() => addDigit(num)}
                  sx={{
                    height: 40,
                    fontSize: "16px",
                    borderColor: "#ccc",
                    color:"#070606ff",
                    "&:hover": { borderColor: "blue" },
                  }}
                >
                  {num}
                </Button>
              </Grid>
            ))}
            


             



            
            {/* Backspace */}
            {/* <Grid item xs={12}>
              <Button
                variant="contained"
                color="warning"
                fullWidth
                onClick={deleteDigit}
                sx={{ marginRight: 0.5, fontSize: "14px", height: 30 }}
              >
                <BackspaceIcon />
              </Button>
            </Grid> */}
          </Grid>

           <Box display="flex" justifyContent="space-between" mt={1.5}>
           

            <Button
              variant="contained"
              color="success"
              fullWidth
              onClick={dial}
              sx={{ marginLeft: 0.5, fontSize: "14px", height: 30 }}
              startIcon={<CallIcon sx={{ color: "#00C853" }} />}
            >
              Call
            </Button>

            <Button
                variant="contained"
                color="warning"
                fullWidth
                onClick={deleteDigit}
                sx={{ marginRight: 0.5, fontSize: "14px", height: 30 }}
              >
                <BackspaceIcon />
              </Button>
          </Box>

          {/* Action Buttons */}
          <Box display="flex" justifyContent="space-between" mt={1.5}>
            <Button
              variant="contained"
              color="error"
              fullWidth
              onClick={handleCancel}
              sx={{ marginRight: 0.5, fontSize: "14px", height: 30 }}
            >
              Cancel
            </Button>

            {/* <Button
              variant="contained"
              color="success"
              fullWidth
              onClick={dial}
              sx={{ marginLeft: 0.5, fontSize: "14px", height: 30 }}
              startIcon={<CallIcon sx={{ color: "#00C853" }} />}
            >
              Call
            </Button> */}
          </Box>

          

          {/* PROGRESS NOTE */}
           <form onSubmit={handleSubmit}>
            <Grid item xs={12}>
          <TextField
            label="Add Notes"
            variant="outlined"
            size="small"
            fullWidth
            multiline
            minRows={2}
           value={progressNote.notes}
              onChange={(e) =>
  setProgressNote((prev) => ({
    ...prev,
    notes: e.target.value,
  }))
}
            sx={{ mt: 1.5 }}
          
          />
           

          </Grid>
          <Grid item xs={12}>
            <MDButton
    variant="contained"
     type="submit"
   
    fullWidth
   
    sx={{ mt: 1.5, fontSize: "14px", height: 30, backgroundColor: "#1A237E",
         color: "#fff", textTransform: "none",
         "&:hover": {
      backgroundColor:  "#1A237E", // darker shade on hover
    },
         }}
  >
    Save Note
  </MDButton>
  </Grid>
  </form>
        </Card>
      </Box>
    </Modal>
  );
}

export default DoctorPhoneCallModal;
